import currencyFormatting from '../currencyFormatting';

export const getPriceRange = (minPrice: string | null, maxPrice: string | null) => {
  if (minPrice != null && maxPrice != null && !(minPrice === maxPrice)) {
    const min = (((minPrice as any) * 100) / 100).toFixed(2);
    const max = (((maxPrice as any) * 100) / 100).toFixed(2);
    const resultMin = currencyFormatting(Number(min));
    const resultMax = currencyFormatting(Number(max));
    if (resultMin && resultMax) {
      return `${resultMin} - ${resultMax}`;
    }
  }
  return null;
};
